export enum StorageKey {
  AuthData = 'auth_data',
  UserData = 'user_data',
  Permission = 'permission',
  GameDetailData = 'RaStore.game-detail.listParams',
}
export class XStorage {
  public static async get<T>(key: StorageKey): Promise<T | null> {
    try {
      const data = localStorage.getItem(key);
      if (!data) return null;
      return JSON.parse(data) as T;
    } catch (error) {
      console.error(`Get storage with key ${key} failed:`, error);
      return null;
    }
  }
  public static async set(key: StorageKey, value: any) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Save data to storage with key ${key} failed:`, error);
    }
  }
  public static async remove(key: StorageKey) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Remove data in storage with key ${key} failed:`, error);
    }
  }

  public static async getWithTTL<T>(key: StorageKey, ttlMs: number): Promise<T | null> {
    try {
      const data = localStorage.getItem(key);
      const timestamp = localStorage.getItem(`${key}_time`);

      if (!data || !timestamp) return null;

      const now = Date.now();
      const cacheTime = parseInt(timestamp, 10);

      // Nếu cache hết hạn, xóa và trả về null
      if (now - cacheTime > ttlMs) {
        await this.remove(key);
        localStorage.removeItem(`${key}_time`);
        return null;
      }

      return JSON.parse(data) as T;
    } catch (error) {
      console.error(`Get storage with TTL key ${key} failed:`, error);
      return null;
    }
  }

  // Thêm method để set với timestamp
  public static async setWithTTL(key: StorageKey, value: any) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      localStorage.setItem(`${key}_time`, Date.now().toString());
    } catch (error) {
      console.error(`Save data to storage with TTL key ${key} failed:`, error);
    }
  }
}
